export const ANALYTICS_EVENTS = {
  addShippingInfo: "addShippingInfo",
  checkoutItemQtyChange: "checkout.itemQtyChange",
  continueToPurchaseConfirmation: "continuedToPurchaseConfirmation",
  couponCodeApplied: "couponCodeApplied",
  orderPurchaseError: "orderPurchaseError",
  orderReview: "orderReview",
  orderSummaryView: "orderSummaryPageView",
  purchaseCompleted: "purchase.completed",
  purchaseEmailOptIn: "purchase.emailOptIn",
  subDetailsCancelClick: "subscriptionDetails.cancelButtonClick",
  subDetailsEditAddressClick: "subscriptionDetails.editAddressClick",
  subDetailsEditPaymentClick: "subscriptionDetails.editPaymentClick",
  subDetailsPageView: "subscriptionsDetails.PageView",
  subDetailsPauseClick: "subscriptionDetails.pauseButtonClick",
  subDetailsResumeClick: "subscriptionDetails.resumeButtonClick",
  subsListPageView: "subscriptionsList.pageView",
  userChanged: "userChanged",
};
